const getSubdomainUrl = (subdomain: string) => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;

    // Remove www if present
    const baseDomain = hostname.replace(/^www\./, "");

    return `${window.location.protocol}//${subdomain}.${baseDomain}/`;
  }

  return "";
};

export const getPanelUrl = () => getSubdomainUrl("panel");

export const getInstallerPanelUrl = () => getSubdomainUrl("installer");